import { IPromise, IQService, IScope } from "angular";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../shared/components/views/machines/detail/tabs";
import { Machine } from "../models/machine";
import { MachineConfiguration } from "../models/machineConfiguration";
import { IReportGroup } from "../../../reporting/interfaces/IReportGroup";
import { vsName as partTransactionComponentName } from "../../../parts/Pages/detail/partTransaction";
import { vsComponentName as machinePartsComponentName } from "../../../parts.machines/components/machineParts";
import {
  ServerUtility,
  vsName as serverUtilityName,
} from "../../../records/server/serverUtility";
import { MachineDetailConfigurationViewArgs } from "../../shared/components/views/machines/detail/views/configurations/controller";
import { getChangeJournalViewStateDefinition } from "../../../records/changeJournal/changeJournalViewComponent/registration";
import {
  machineConfigurationObjectName,
  machineObjectName,
} from "../../shared/names";
import { ChangeJournalObject } from "../../../records/changeJournal/changeJournalViewComponent/models";
export function machineDetailTabComponentConfigure(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider
    .addElement({
      displayName: "Configurations",
      id: "configurations",
      uiSrefFragment: "configurations",
      requiredPermission: "machineView",
      children: [],
      stateDefinition: {
        url: "/configurations",
        template: require("!html-loader!./configurations.html").default,
        controller: [
          "$scope",
          "machine",
          "reportGroup",
          ($scope: IScope, machine: Machine, reportGroup: IReportGroup) => {
            const s = <any>$scope;
            s.machine = machine;
            s.reportGroup = reportGroup;
            s.editSref = "^.edit";
            s.accordionHeading = (args: MachineDetailConfigurationViewArgs) => {
              const machineConfiguration = <MachineConfiguration>(
                args.machineConfiguration
              );
              const { changeIsPending, dateString, currentConfiguration } =
                args;

              const suffix =
                machineConfiguration.ChangeType === "Conversion"
                  ? machineConfiguration?.MachineConversionType?.Name
                  : machineConfiguration.ChangeType === "Decommission"
                  ? machineConfiguration?.MachineDecommissionType?.Name
                  : machineConfiguration.ChangeType === "Warehouse"
                  ? machineConfiguration.MachineWarehouseType?.Name
                  : undefined;

              const changeType =
                machineConfiguration.ChangeType! +
                (suffix ? ` (${suffix})` : "");

              return `${changeType} - ${dateString}${
                currentConfiguration && !changeIsPending ? " - Current" : ""
              }${changeIsPending ? " - Pending" : ""}`;
            };
          },
        ],
      },
    })
    .addElement({
      displayName: "Part Transactions",
      id: "parts",
      uiSrefFragment: "parts",
      requiredPermission: "machineView",
      stateDefinition: {
        url: "/parts",
        component: partTransactionComponentName,
        resolve: {
          partTransaction: [
            "machine",
            serverUtilityName,
            (machine: Machine, serverUtility: ServerUtility) => {
              if (!machine || !machine.Id) {
                return [];
              }
    
              return serverUtility.sendApiRequest({
                method: "GET",
                url: "/api/parts/partTransaction",
                params: {
                  ContextPath: "MachineId",
                  ContextValue: machine.Id,
                },
              });
            },
          ],
    
          part: [
            "machine",
            (machine: Machine) => ({
              Id: null,
              PartNumber: "Machine Parts",
              PartDescription: machine.Name,
            }),
          ],
        },
      },
    })
    
    .addElement({
      displayName: "Change Log",
      id: "changeLog",
      uiSrefFragment: "changeLog",
      requiredPermission: "machineView",
      stateDefinition: getChangeJournalViewStateDefinition({
        resolveObjects: [
          "machine",
          "$q",
          (machine: Machine, $q: IQService): IPromise<ChangeJournalObject[]> =>
            $q.when([
              {
                id: { ObjectId: machine.Id, ObjectName: machineObjectName },
                object: machine,
              },
              ...(machine.Configs?.map((c) => ({
                id: {
                  ObjectId: c.Id,
                  ObjectName: machineConfigurationObjectName,
                },
                object: c,
              })) ?? []),
            ]),
        ],
      }),
    });
  /* TODO - add client specific tabs here if needed (preferred method is to have included modules add to it) */
}
machineDetailTabComponentConfigure.$inject = [MachineDetailTabsProviderName];
